export default __webpack_public_path__ + "static/media/snake_thumbnail.eba6ee94.png";